import { api } from "@/lib/api";
import {
  TourServiceDto,
  tourServiceDtoListSchema,
  tourServiceFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getTourServicesQueryOptions(tourId: string) {
  return queryOptions({
    queryKey: ["tour-services", tourId],
    queryFn: async () => {
      const result: Array<TourServiceDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/tour-services",
          tourServiceDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              TourId: Number.parseInt(tourId),
            },
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(tourServiceFromDto);
    },
  });
}

export function useGetTourServices(tourId: string) {
  return useQuery(getTourServicesQueryOptions(tourId));
}
